import MyRemoteVideo from '@components/MyRemoteVideo';
import PeerVideos from '@components/PeerVideos';
import FeatureController from '@fragments/FeatureController';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';
import { attendeeInfo } from '@stores/selectors/loginInfo';
import { useAtomValue } from 'jotai';
import { Container, IntervieweeInfo, InterviewersArea } from './style';

const InterviewerHeader = () => {
  const { recruitNoticeName, name } = useAtomValue(attendeeInfo);
  const { getInterviewInfo } = useInterviewSession();

  const nameText =
    getInterviewInfo().nameBlindYn === 'true' ? '(블라인드)' : `(${name})`;

  return (
    <Container>
      <IntervieweeInfo
        title={`${recruitNoticeName}${nameText}`}
      >{`${recruitNoticeName}${nameText}`}</IntervieweeInfo>

      <FeatureController />

      <InterviewersArea>
        <PeerVideos />
        <MyRemoteVideo nameplate={getInterviewInfo().name} />
      </InterviewersArea>
    </Container>
  );
};

export default InterviewerHeader;
